var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#2D2D2D" }
    },
    [
      _c(
        "el-col",
        {
          staticStyle: { display: "flex", "justify-content": "center" },
          attrs: { span: 24 }
        },
        [
          _c("img", {
            staticStyle: {
              width: "100%",
              height: "230px",
              "object-fit": "cover"
            },
            attrs: {
              loading: "lazy",
              src: require("../../assets/side-advertisement-3.png")
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-254ffb00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254ffb00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/advertisementThree.vue
// module id = null
// module chunks = 